export default __webpack_public_path__ + "static/media/giftcard.a6b1bcf6.jpg";